module.exports = "/assets/data/be6ad50f215db46ddb59c61fe851be67-BA22.data.json";